import { render } from "./KanbanContent.vue?vue&type=template&id=4c043b4c"
import script from "./KanbanContent.vue?vue&type=script&lang=js"
export * from "./KanbanContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__